export default function Button({ variant = 'primary', size, type = 'button', children, ...props }) {
  const cls = `btn btn-${variant}${size ? ` btn-${size}` : ''}`;
  return <button type={type} class={cls} {...props}>{children}</button>;
}
